// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import CertificationController from "./certification_controller"
application.register("certification", CertificationController)

import ContactsController from "./contacts_controller"
application.register("contacts", ContactsController)

import JobSearchController from "./job_search_controller"
application.register("job-search", JobSearchController)

import LandingController from "./landing_controller"
application.register("landing", LandingController)

import RegistrationController from "./registration_controller"
application.register("registration", RegistrationController)

import WorkExperienceController from "./work_experience_controller"
application.register("work-experience", WorkExperienceController)
